import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import DatiPazienteTubercolosi from "./Sezioni/DatiPazienteTubercolosi";
import DatiSegnalazioneTubercolosi from "./Sezioni/DatiSegnalazioneTubercolosi";
import CaratteristicheDellaMalattiaTubercolosi from "./Sezioni/CaratteristicheDellaMalattiaTubercolosi";
import CaratteristicheDellaDiagnosiTubercolosi from "./Sezioni/CaratteristicheDellaDiagnosiTubercolosi";
import FattoriDiRischioTubercolosi from "./Sezioni/FattoriDiRischioTubercolosi";
import DatiDelCompilatoreTubercolosi from "./Sezioni/DatiDelCompilatoreTubercolosi";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli";
import Utils from "../../../../../../utils/Utils";


class SchedaSpecialeTubercolosi extends Component {

    state = {
        schedaSpecialeTubercolosi: {
            datiSegnalazioneTubercolosi: {},
            datiPazienteTubercolosi: {},
            caratteristicheDellaMalattiaTubercolosi: {},
            caratteristicheDellaDiagnosiTubercolosi: {},
            fattoriDiRischioTubercolosi: {},
            datiCompilatoreTubercolosi: {}
        },
        validateTubercolosi: {
            caratteristicheDellaMalattiaTubercolosi: "",
            datiPazienteTubercolosi: ""
        },
        controlloCorrettezza: "",
        corretto: [],
        oggettoBe: {}
    }

    constructor(props) {
        super(props);
        this.setDatiSegnalazioneTubercolosi = this.setDatiSegnalazioneTubercolosi.bind(this)
        this.setDatiPazienteTubercolosi = this.setDatiPazienteTubercolosi.bind(this)
        this.setCaratteristicheDellaMalattiaTubercolosi = this.setCaratteristicheDellaMalattiaTubercolosi.bind(this)
        this.setCaratteristicheDellaDiagnosiTubercolosi = this.setCaratteristicheDellaDiagnosiTubercolosi.bind(this)
        this.setFattoriDiRischioTubercolosi = this.setFattoriDiRischioTubercolosi.bind(this)
        this.setDatiCompilatoreTubercolosi = this.setDatiCompilatoreTubercolosi.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.validate = this.validate.bind(this)

    }

    componentDidMount() {
        this.props.setSchedaSpecialeECorretto(this.state.oggettoBe, "", this.state.corretto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            this.props.setSchedaSpecialeECorretto(this.state.oggettoBe, this.validate(), this.state.corretto)
        }
    }

    validate() {
        let validate = this.state.validateTubercolosi

        for (let key in validate) {
            if (validate[key]) {
                return validate[key]
            }
        }

        return ""
    }

    setDatiSegnalazioneTubercolosi(datiSegnalazioneTubercolosi, datiSegnalazioneTubercolosiBe) {
        let schedaSpecialeTubercolosi = this.state.schedaSpecialeTubercolosi
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeTubercolosi.datiSegnalazioneTubercolosi = datiSegnalazioneTubercolosi
        oggettoBe["datiSegnalazione"] = datiSegnalazioneTubercolosiBe
        if (datiSegnalazioneTubercolosi !== undefined && datiSegnalazioneTubercolosiBe === undefined) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi})
        } else if (datiSegnalazioneTubercolosi === undefined && datiSegnalazioneTubercolosiBe !== undefined) {
            this.setState({oggettoBe: oggettoBe})
        } else if (datiSegnalazioneTubercolosi !== undefined && datiSegnalazioneTubercolosiBe) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi, oggettoBe: oggettoBe})
        }
        this.controlloCorrettezza()
    }

    setDatiPazienteTubercolosi(datiPazienteTubercolosi, valdatePaziente, datiPazienteTubercolosiBe) {
        let schedaSpecialeTubercolosi = this.state.schedaSpecialeTubercolosi
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeTubercolosi.datiPazienteTubercolosi = datiPazienteTubercolosi
        oggettoBe["datiPaziente"] = datiPazienteTubercolosiBe
        let validate = this.state.validateTubercolosi
        validate.datiPazienteTubercolosi = valdatePaziente

        if (datiPazienteTubercolosi && datiPazienteTubercolosiBe && valdatePaziente) {
            this.setState({
                schedaSpecialeTubercolosi: schedaSpecialeTubercolosi,
                oggettoBe: oggettoBe,
                validateTubercolosi: validate
            })
        } else if (!datiPazienteTubercolosi && datiPazienteTubercolosiBe && valdatePaziente) {
            this.setState({oggettoBe: oggettoBe, validateTubercolosi: validate})
        } else if (datiPazienteTubercolosi && !datiPazienteTubercolosiBe && valdatePaziente) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi, validateTubercolosi: validate})
        } else if (datiPazienteTubercolosi && datiPazienteTubercolosiBe && !valdatePaziente) {
            this.setState({oggettoBe: oggettoBe, schedaSpecialeTubercolosi: schedaSpecialeTubercolosi})
        } else if (datiPazienteTubercolosi && !datiPazienteTubercolosiBe && !valdatePaziente) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi})
        } else if (!datiPazienteTubercolosi && datiPazienteTubercolosiBe && !valdatePaziente) {
            this.setState({oggettoBe: oggettoBe})
        } else if (!datiPazienteTubercolosi && !datiPazienteTubercolosiBe && valdatePaziente) {
            this.setState({validateTubercolosi: validate})
        }

        this.controlloCorrettezza()
    }

    setCaratteristicheDellaMalattiaTubercolosi(caratteristicheDellaMalattiaTubercolosi, validateMalattia, caratteristicheDellaMalattiaTubercolosiBe, controlloCorrettezza) {
        let schedaSpecialeTubercolosi = this.state.schedaSpecialeTubercolosi
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeTubercolosi.caratteristicheDellaMalattiaTubercolosi = caratteristicheDellaMalattiaTubercolosi
        oggettoBe["caratteristicheDellaMalattia"] = caratteristicheDellaMalattiaTubercolosiBe
        let validate = this.state.validateTubercolosi
        validate.caratteristicheDellaMalattiaTubercolosi = validateMalattia

        if (caratteristicheDellaMalattiaTubercolosi && caratteristicheDellaMalattiaTubercolosiBe && validateMalattia && controlloCorrettezza) {
            this.setState({
                schedaSpecialeTubercolosi: schedaSpecialeTubercolosi,
                oggettoBe: oggettoBe,
                validateTubercolosi: validate,
                controlloCorrettezza: controlloCorrettezza
            })
        } else if (!caratteristicheDellaMalattiaTubercolosi && caratteristicheDellaMalattiaTubercolosiBe && validateMalattia && controlloCorrettezza) {
            this.setState({
                oggettoBe: oggettoBe,
                validateTubercolosi: validate,
                controlloCorrettezza: controlloCorrettezza
            })
        } else if (caratteristicheDellaMalattiaTubercolosi && !caratteristicheDellaMalattiaTubercolosiBe && validateMalattia && controlloCorrettezza) {
            this.setState({
                schedaSpecialeTubercolosi: schedaSpecialeTubercolosi,
                validateTubercolosi: validate,
                controlloCorrettezza: controlloCorrettezza
            })
        } else if (caratteristicheDellaMalattiaTubercolosi && caratteristicheDellaMalattiaTubercolosiBe && !validateMalattia && controlloCorrettezza) {
            this.setState({
                oggettoBe: oggettoBe,
                schedaSpecialeTubercolosi: schedaSpecialeTubercolosi,
                controlloCorrettezza: controlloCorrettezza
            })
        } else if (caratteristicheDellaMalattiaTubercolosi && caratteristicheDellaMalattiaTubercolosiBe && validateMalattia && !controlloCorrettezza) {
            this.setState({
                oggettoBe: oggettoBe,
                schedaSpecialeTubercolosi: schedaSpecialeTubercolosi,
                validateTubercolosi: validate
            })
        } else if (caratteristicheDellaMalattiaTubercolosi && !caratteristicheDellaMalattiaTubercolosiBe && !validateMalattia && !controlloCorrettezza) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi})
        } else if (!caratteristicheDellaMalattiaTubercolosi && caratteristicheDellaMalattiaTubercolosiBe && !validateMalattia && !controlloCorrettezza) {
            this.setState({oggettoBe: oggettoBe})
        } else if (!caratteristicheDellaMalattiaTubercolosi && !caratteristicheDellaMalattiaTubercolosiBe && validateMalattia && !controlloCorrettezza) {
            this.setState({validateTubercolosi: validate})
        } else if (!caratteristicheDellaMalattiaTubercolosi && !caratteristicheDellaMalattiaTubercolosiBe && !validateMalattia && controlloCorrettezza) {
            this.setState({controlloCorrettezza: controlloCorrettezza})
        }
        this.controlloCorrettezza()
    }

    setCaratteristicheDellaDiagnosiTubercolosi(caratteristicheDellaDiagnosiTubercolosi, caratteristicheDellaDiagnosiTubercolosiBe) {
        let schedaSpecialeTubercolosi = this.state.schedaSpecialeTubercolosi
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeTubercolosi.caratteristicheDellaDiagnosiTubercolosi = caratteristicheDellaDiagnosiTubercolosi
        oggettoBe["caratteristicheDellaDiagnosi"] = caratteristicheDellaDiagnosiTubercolosiBe
        if (caratteristicheDellaDiagnosiTubercolosi !== undefined && caratteristicheDellaDiagnosiTubercolosiBe === undefined) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi})
        } else if (caratteristicheDellaDiagnosiTubercolosi === undefined && caratteristicheDellaDiagnosiTubercolosiBe !== undefined) {
            this.setState({oggettoBe: oggettoBe})
        } else if (caratteristicheDellaDiagnosiTubercolosi !== undefined && caratteristicheDellaDiagnosiTubercolosiBe) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi, oggettoBe: oggettoBe})
        }
        this.controlloCorrettezza()
    }

    setFattoriDiRischioTubercolosi(fattoriDiRischioTubercolosi, fattoriDiRischioTubercolosiBe) {
        let schedaSpecialeTubercolosi = this.state.schedaSpecialeTubercolosi
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeTubercolosi.fattoriDiRischioTubercolosi = fattoriDiRischioTubercolosi
        oggettoBe["fattoriDiRischio"] = fattoriDiRischioTubercolosiBe
        if (fattoriDiRischioTubercolosi !== undefined && fattoriDiRischioTubercolosiBe === undefined) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi})
        } else if (fattoriDiRischioTubercolosi === undefined && fattoriDiRischioTubercolosiBe !== undefined) {
            this.setState({oggettoBe: oggettoBe})
        } else if (fattoriDiRischioTubercolosi !== undefined && fattoriDiRischioTubercolosiBe) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi, oggettoBe: oggettoBe})
        }
        this.controlloCorrettezza()
    }

    setDatiCompilatoreTubercolosi(datiCompilatoreTubercolosi, datiCompilatoreTubercolosiBe) {
        let schedaSpecialeTubercolosi = this.state.schedaSpecialeTubercolosi
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeTubercolosi.datiCompilatoreTubercolosi = datiCompilatoreTubercolosi
        oggettoBe["datiCompilatore"] = datiCompilatoreTubercolosiBe
        if (datiCompilatoreTubercolosi !== undefined && datiCompilatoreTubercolosiBe === undefined) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi})
        } else if (datiCompilatoreTubercolosi === undefined && datiCompilatoreTubercolosiBe !== undefined) {
            this.setState({oggettoBe: oggettoBe})
        } else if (datiCompilatoreTubercolosi !== undefined && datiCompilatoreTubercolosiBe) {
            this.setState({schedaSpecialeTubercolosi: schedaSpecialeTubercolosi, oggettoBe: oggettoBe})
        }
        this.controlloCorrettezza()
    }

    controlloCorrettezza() {

        let schedaSpecialeTubercolosi = this.state.schedaSpecialeTubercolosi
        let textList = []

        if(schedaSpecialeTubercolosi.datiPazienteTubercolosi.corretto && schedaSpecialeTubercolosi.datiPazienteTubercolosi.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeTubercolosi.datiPazienteTubercolosi.corretto))
        }
        if(schedaSpecialeTubercolosi.caratteristicheDellaDiagnosiTubercolosi.corretto && schedaSpecialeTubercolosi.caratteristicheDellaDiagnosiTubercolosi.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeTubercolosi.caratteristicheDellaDiagnosiTubercolosi.corretto))
        }
        if(schedaSpecialeTubercolosi.fattoriDiRischioTubercolosi.corretto && schedaSpecialeTubercolosi.fattoriDiRischioTubercolosi.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeTubercolosi.fattoriDiRischioTubercolosi.corretto))
        }
        if(schedaSpecialeTubercolosi.caratteristicheDellaMalattiaTubercolosi.corretto && schedaSpecialeTubercolosi.caratteristicheDellaMalattiaTubercolosi.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeTubercolosi.caratteristicheDellaMalattiaTubercolosi.corretto))
        }

        this.setState({corretto: textList})
    }

    render() {

        return (
            <div
                className={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "visualizzazione" : ""}>
                <fieldset
                    disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}>
                    <DatiSegnalazioneTubercolosi
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setDatiSegnalazioneTubercolosi={this.setDatiSegnalazioneTubercolosi}/>
                    <DatiPazienteTubercolosi
                        datiPaziente={this.props.datiPaziente}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setDatiPazienteTubercolosi={this.setDatiPazienteTubercolosi}/>
                    <CaratteristicheDellaDiagnosiTubercolosi
                        controlloCorrettezza={this.state.controlloCorrettezza}
                        caratteristicheDellaMalattiaTubercolosi={this.state.schedaSpecialeTubercolosi.caratteristicheDellaMalattiaTubercolosi}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setCaratteristicheDellaDiagnosiTubercolosi={this.setCaratteristicheDellaDiagnosiTubercolosi}/>


                    <FattoriDiRischioTubercolosi
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setFattoriDiRischioTubercolosi={this.setFattoriDiRischioTubercolosi}/>

                    <CaratteristicheDellaMalattiaTubercolosi
                        caratteristicheDellaDiagnosiTubercolosi={this.state.schedaSpecialeTubercolosi.caratteristicheDellaDiagnosiTubercolosi}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setCaratteristicheDellaMalattiaTubercolosi={this.setCaratteristicheDellaMalattiaTubercolosi}/>

                    <DatiDelCompilatoreTubercolosi
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setDatiCompilatoreTubercolosi={this.setDatiCompilatoreTubercolosi}/>
                </fieldset>
            </div>
        );
    }

}

export default withTranslation('common')(SchedaSpecialeTubercolosi)
